import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { toggleTheme, setTheme, initializeTheme, selectTheme, selectIsDarkMode } from '../features/theme/themeSlice'

/**
 * Custom hook to manage application theme
 * 
 * @returns {Object} Object with current theme and functions to manipulate it
 * @property {string} theme - Current theme ('light' or 'dark')
 * @property {boolean} isDarkMode - true if dark mode is active
 * @property {Function} toggle - Function to toggle between light and dark
 * @property {Function} setThemeMode - Function to set a specific theme
 */
export const useTheme = () => {
  const dispatch = useDispatch()
  const theme = useSelector(selectTheme)
  const isDarkMode = useSelector(selectIsDarkMode)

  // Initialize theme when hook mounts
  useEffect(() => {
    dispatch(initializeTheme())
  }, [dispatch])

  const toggle = () => {
    dispatch(toggleTheme())
  }

  const setThemeMode = (mode) => {
    dispatch(setTheme(mode))
  }

  return {
    theme,
    isDarkMode,
    toggle,
    setThemeMode
  }
}

